import { Injectable } from '@angular/core';
import { Router, CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthorizationService } from '../services';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class LLFormAuthorizationGuard implements CanActivate, CanLoad {
    constructor(private router: Router, private authService: AuthorizationService, private toastr: ToastrService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.checkAccess();
    }

    canLoad(state: Route): Observable<boolean> {
        return this.checkAccess();
    }

    private checkAccess(): Observable<boolean> {
        let bhasPermission = false;

        bhasPermission = this.authService.hasPermission('SSDP.CanReadLLForm') || this.authService.hasPermission('SSDP.CanWriteLLForm');

        if (!bhasPermission) {
            this.toastr.error('You do not have access to this page.');
            this.router.navigate(['/home']);
        }

        return of(bhasPermission) ;
    }
}
